import { render, staticRenderFns } from "./budgetControls.vue?vue&type=template&id=3dc73498"
import script from "./budgetControls.vue?vue&type=script&lang=js"
export * from "./budgetControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc73498')) {
      api.createRecord('3dc73498', component.options)
    } else {
      api.reload('3dc73498', component.options)
    }
    module.hot.accept("./budgetControls.vue?vue&type=template&id=3dc73498", function () {
      api.rerender('3dc73498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/budgetControls.vue"
export default component.exports